import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthLayout, Field, SubmitBtn, ErrorMsg } from "@/pages/Login";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Password must be at least 8 characters");
    if (password !== confirm) return setError("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!token)
    return (
      <AuthLayout title="Invalid link">
        <p className="text-sm text-slate-600 mb-4">This reset link is missing its token.</p>
        <Link to="/forgot-password" className="text-sm text-blue-700 hover:underline">Request a new link</Link>
      </AuthLayout>
    );

  return (
    <AuthLayout title="Set a new password" description="Choose a strong password (min 8 characters).">
      <form onSubmit={submit} data-testid="reset-form">
        <ErrorMsg>{error}</ErrorMsg>
        <Field label="New password" type="password" required value={password} data-testid="reset-password"
          onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
        <Field label="Confirm password" type="password" required value={confirm} data-testid="reset-confirm"
          onChange={(e) => setConfirm(e.target.value)} placeholder="••••••••" />
        <SubmitBtn loading={loading} data-testid="reset-submit">Update password</SubmitBtn>
      </form>
    </AuthLayout>
  );
}
